module.exports = __webpack_public_path__ + "static/media/EEB560.d57906d2.svg";